import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { Session } from 'src/app/modules/security/login/shared/session.model';
import { CONSTANT } from '../common/constant.service';

@Injectable()
export class SessionInfo {
  private keySession: string = "dataUserZ2HSession";
  private keyModule: string = "dataUserZ2HMouleID";
  private session: Session
  private moduleID: number;

  getAudit() {
    let userDefault;
    //let userSession;
    let codUsuarioSession;

    this.session = JSON.parse(localStorage.getItem(this.keySession));

    if (!environment.production)
      userDefault = environment.userDefault;

    codUsuarioSession = this.session ? this.session.UserName : userDefault;
    return codUsuarioSession;
  }


  setModuleID(moduleID: number): void {
    localStorage.setItem(this.keyModule, String(moduleID));
  }

  getModuleID(): number {
    this.moduleID = Number(localStorage.getItem(this.keyModule));
    if (!this.moduleID)
      return CONSTANT.ModuleIDDefault;
    else
      return this.moduleID;
  }

  getCodUsuario(): string {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.UserName;
    else
      return "";
    // return "HLopez";
  }

  getUrlFoto(): string {
    let infoUserSession: any = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return infoUserSession[0].urlFoto;
    else
      return "";
    // return "HLopez";
  }

  getNomApellidos(): string {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.Description;
    else
      return "";
    //return "HLopez";
  }

  getOfficeID(): number {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.OfficeID;
    else
      return 0
    // return this.session.UserName;
    //return this.session.nomApellidos;
  }
  getOfficeName(): any {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.OfficeName;
    else
      return 0
    // return this.session.UserName;
    //return this.session.nomApellidos;
  }

  getAplicacionID(): number {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.AplicacionID;
    else
      return 0
    // return this.session.UserName;
    //return this.session.nomApellidos;
  }

  getEmpresaID(): number {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.EmpresaID;
    else
      return 0
    // return this.session.UserName;
    //return this.session.nomApellidos;
  }
  getEmpresaName(): any {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.EmpresaName;
    else
      return 0
    // return this.session.UserName;
    //return this.session.nomApellidos;
  }
  getRoleID(): number {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.RoleID;
    else
      return 0
    // return this.session.UserName;
    //return this.session.nomApellidos;
  }

  getIdNivelAcceso(): number {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.idNivelAcceso;
    else
      return 0
  }

  getIdEntidad(): number {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.idEntidad;
    else
      return 0
  }

  getNivelAccesoName(): any {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.nivelAccesoName;
    else
      return 0
  }

  getEntidadName(): any {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.entidadName;
    else
      return 0
  }

  getIdUsuario(): number {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.UserID;
    else
      return 0
  }

  getVentanasDefecto(): any {
    // let infoUserSession : any = JSON.parse(localStorage.getItem(this.keySession));
    // return infoUserSession;
  }

  getPerfiles(): any {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.RoleName;
    else
      return "";
    // return "Adm"
  }

  getFecActivacion(): any {
    this.session = JSON.parse(localStorage.getItem(this.keySession));
    if (this.session)
      return this.session.DateCreation;
    // return "20-12-2012"
  }

  setAudit(dataSession: string): void {
    localStorage.setItem(this.keySession, dataSession);
  }

  delAudit(): void {
    localStorage.removeItem(this.keySession);
    localStorage.clear();
  }
}
